import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';

function Vision() {
    return (
        <Container className="vision-page editorial-page">
            <section className="vision-hero editorial-hero">
                <p className="vision-kicker editorial-kicker">Budgetvenlig</p>
                <h1 className="editorial-title">Vores vision</h1>
                <p className="vision-lead editorial-lead">
                    Vores vision med Budgetvenlig er at gøre det lettere at navigere i Danmarks mange dagligvarebutikker
                    og ugentlige tilbud.
                </p>
                <ul className="vision-pillars editorial-pill-list" aria-label="Budgetvenlig proces">
                    <li>Tilbud</li>
                    <li>Retter</li>
                    <li>Indkøb</li>
                    <li>Mad</li>
                    <li>Rester</li>
                </ul>
            </section>

            <div className="vision-layout editorial-layout">
                <aside className="vision-nav editorial-side-nav" aria-label="Indhold">
                    <p className="vision-nav-title editorial-nav-title">På denne side</p>
                    <a href="#hvorfor">Hvorfor Budgetvenlig</a>
                    <a href="#supermarkederne-samles">Supermarkederne samles</a>
                    <a href="#retter-som-pejlemaerke">Retter som pejlemærke</a>
                    <a href="#fra-ret-til-indkoeb">Fra ret til indkøb</a>
                    <a href="#i-sidste-ende">I sidste ende</a>
                    <Link to="/recipes" className="vision-nav-cta editorial-nav-cta">Se opskrifter</Link>
                </aside>

                <article className="vision-article editorial-article">
                    <section className="vision-section editorial-section" id="hvorfor">
                        <h2>Hvorfor Budgetvenlig</h2>
                        <p>
                            Dagligvareindkøb er for mange blevet en støjende oplevelse. Supermarkederne rummer i dag alt fra
                            aftensmad og husholdningsvarer til kampagner, medlemsapps og tilbud, der hele tiden konkurrerer om
                            opmærksomheden. Når man egentlig bare vil finde ud af, hvad der giver mening at lave til aften, kan
                            det hurtigt føles uoverskueligt.
                        </p>
                        <p>
                            Budgetvenlig vil skære gennem den støj. Ved at vise hvilke retter der giver bedst mening at lave ud
                            fra ugens tilbud, vil vi hjælpe den travle dansker med at træffe enklere valg i hverdagen.
                        </p>
                    </section>

                    <section className="vision-section editorial-section" id="supermarkederne-samles">
                        <h2>Supermarkederne samles</h2>
                        <p>
                            Danmark har et bredt udvalg af supermarkeder, og de konkurrerer i stigende grad gennem ugentlige
                            tilbud. Hver butik fremhæver udvalgte varer til særligt lave priser for at tiltrække kunder. Den ene
                            uge kan Rema 1000 for eksempel have tilbud på æg, fløde og kartofler, mens Netto samtidig reklamerer
                            med store besparelser på kyllingefilet.
                        </p>
                        <p>
                            Tidligere betød det, at man som forbruger måtte vælge, hvilken butik man ville handle i den uge.
                            Supermarkederne lå ofte længere fra hinanden, og det var ikke praktisk at besøge flere.
                        </p>
                        <p>
                            Men i dag ser landskabet anderledes ud. I både storbyer og mindre byer ligger supermarkederne ofte tæt
                            på hinanden. På en travl gade i København kan man for eksempel finde en Føtex og en 365 Discount inden
                            for få hundrede meter, og i mange provinsbyer ligger flere supermarkeder side om side omkring de samme
                            indfaldsveje og parkeringspladser.
                        </p>
                        <p>
                            Supermarkederne konkurrerer ikke længere primært med den lokale bager eller slagter, men i høj grad med
                            hinanden. Resultatet er et landskab, hvor flere butikker ligger side om side, hver med deres egne tilbud.
                        </p>
                        <p>
                            Det betyder, at tilbud ikke længere behøver at være et enten-eller. Med et målrettet blik kan man
                            bevæge sig fra butik til butik og samle ugens bedste tilbud på kort tid.
                        </p>
                    </section>

                    <section className="vision-section editorial-section" id="retter-som-pejlemaerke">
                        <h2>Retter som pejlemærke</h2>
                        <p>
                            Når supermarkederne ligger tæt, og hver butik fremhæver forskellige tilbud, opstår der en ny mulighed
                            for forbrugeren. Man kan i princippet samle ugens bedste priser på tværs af flere butikker.
                        </p>
                        <p>
                            Men her opstår et andet problem. Tilbuddene fortæller os, hvad der er billigt, men de fortæller os ikke,
                            hvad vi faktisk skal bruge dem til.
                        </p>
                        <p>
                            Et tilbud på kylling, et andet på pasta og et tredje på tomatsauce giver først rigtig mening, når de
                            bliver sat ind i en sammenhæng. Det er her retterne kommer ind.
                        </p>
                        <p>
                            En ret fungerer som et pejlemærke. I stedet for at tænke i enkelte varer kan man tænke i måltider: Hvad
                            kan man lave i denne uge, hvis man tager udgangspunkt i de tilbud der findes?
                        </p>
                        <p>
                            Budgetvenlig tager derfor ikke udgangspunkt i varer alene, men i retter. Ved at koble ugens tilbud sammen
                            med en kogebog af simple hverdagsretter kan vi vise, hvilke måltider der giver bedst mening at lave i
                            netop denne uge.
                        </p>
                        <p>
                            På den måde bliver tilbud ikke bare enkeltstående fristelser i supermarkedet, men byggesten til en
                            samlet madplan.
                        </p>
                    </section>

                    <section className="vision-section editorial-section" id="fra-ret-til-indkoeb">
                        <h2>Fra ret til indkøb</h2>
                        <p>
                            Når en ret først fungerer som pejlemærke, bliver resten af processen langt mere overskuelig. I stedet
                            for at gå ind i supermarkedet uden en klar plan kan man tage udgangspunkt i et konkret måltid og se,
                            hvilke ingredienser der er nødvendige.
                        </p>
                        <p>
                            Her vender Budgetvenlig logikken om. I stedet for at starte med en indkøbsliste og forsøge at finde ud
                            af, hvad man kan lave ud fra den, starter vi med retten. Herfra kan vi se, hvilke ingredienser der skal
                            bruges, og hvor det giver bedst mening at købe dem i denne uge.
                        </p>
                        <p>
                            På den måde bliver indkøbet ikke længere en samling af tilfældige varer, men en målrettet proces. Man
                            ved hvad man skal bruge, og hvilke butikker der har de bedste tilbud på netop de ingredienser.
                        </p>
                        <p>
                            Når maden først er lavet, stopper processen heller ikke nødvendigvis der. Ofte vil der være ingredienser
                            tilbage, som ikke blev brugt fuldt ud. I stedet for at lade dem ende bagerst i køleskabet kan de
                            registreres i Budgetvenligs digitale spisekammer.
                        </p>
                        <p>
                            Disse rester bliver herefter en del af næste beslutning. Når nye tilbud dukker op i butikkerne, kan
                            Budgetvenlig foreslå retter, der både udnytter ugens tilbud og de ingredienser man allerede har.
                        </p>
                        <p>
                            På den måde bliver indkøb, madlavning og rester ikke længere separate beslutninger, men en sammenhængende
                            proces, der udvikler sig fra uge til uge.
                        </p>
                    </section>

                    <section className="vision-section editorial-section" id="i-sidste-ende">
                        <h2>I sidste ende</h2>
                        <p>
                            Budgetvenlig er bygget på en enkel idé: at gøre indkøb mindre støjende og mere overskuelige ved at tage
                            udgangspunkt i det, der egentlig betyder noget, nemlig måltidet.
                        </p>
                        <p>
                            Ved at samle ugens tilbud, opskrifter og rester i én sammenhængende proces håber vi at kunne gøre
                            hverdagsindkøb lettere, mere målrettede og mere meningsfulde.
                        </p>
                    </section>
                </article>
            </div>
        </Container>
    );
}

export default Vision;
